<ng-container *ngIf="screenWidth > 1400; else mobileView">
    <header *ngIf="carouselHeader && carouselHeader[0].images">
            <mdb-carousel [controls]="true" [indicators]="true" [animation]="'fade'" [interval]="10000">
                <mdb-carousel-item *ngFor="let slide of carouselHeader[0]?.images" class="carousel-container">
                    <img [src]="slide.fields.file.url" class="d-block w-100 carousel-img" alt="Culture Studio Hero Image" />
                </mdb-carousel-item>
            </mdb-carousel>
    </header>

    
    <div *ngIf="categoryGallery" class="row overflow-hidden" style="margin-top: 4rem; cursor: pointer;">
        <h3 class="category-header">{{ categoryGallery[0].header }}</h3>
        <p class="category-subheader">{{ categoryGallery[0].subheader }}</p>
        <div class="grid overflow-hidden">
            <!-- First row (2 items) -->
            <div class="grid-item first-row overflow-hidden bg-image hover-overlay"
                *ngFor="let category of categoryGallery[0].categories.slice(0, 2)" (click)="redirectTo(category.fields.url)">
                <a href="{{ category.fields.url }}">
                    <img loading="lazy" src="{{ category.fields.images[0].fields.file.url }}" class="img-fluid"
                        [alt]="'Category Image of ' + category.fields.name" />
                    <span class="category-name">{{ category.fields.name }}</span>
                </a>
                <div
                    class="mask"
                    style="
                    background: rgba(251, 251, 251, 0.35)
                    ;
                    "
                ></div>
            </div>
        </div>
    </div>

    <!-- Second row (4 items) -->
    <div *ngIf="categoryGallery" class="second-row-container" style="cursor: pointer;">
        <div class="grid-item bg-image hover-overlay" *ngFor="let category of categoryGallery[0].categories.slice(2, 6)" (click)="redirectTo(category.fields.url)">
            <a href="{{ category.fields.description }}">
                <img loading="lazy" src="{{ category.fields.images[0].fields.file.url }}" style="object-fit: cover"
                    [alt]="'Category Image of ' + category.fields.name" />
                <span class="category-name">{{ category.fields.name }}</span>
            </a>
            <div
            class="mask"
            style="
            background: rgba(251, 251, 251, 0.35)
            ;
            "
            ></div>
        </div>
    </div>


    <div *ngIf="keyFeatures" class="row key-features">
        <div *ngFor="let feature of keyFeatures[0].features" class="col-sm-3">
            <div class="row">
                <div class="col-sm-12 text-center key-feature-item">
                    <img loading="lazy" src="{{feature.fields.icon.fields.file.url}}" class="img-fluid key-feature-item-img"
                        [alt]="feature.title" />
                    <span class="key-feature-name ms-2">{{feature.fields.name}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="cta-container">
        <div *ngIf="callToAction" class="row d-flex justify-content-center align-items-center" style="padding-top: 75px; padding-bottom: 75px;">
            <div class="col-lg-6 col-md-6 col-sm-12" style="padding-left: 125px;">
                <img [src]="callToAction[0].image.fields.file.url" [alt]="callToAction[0].image.fields.title" class="img-fluid">
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12" style="padding: 8rem;">
                <div class="cta-header">{{ callToAction[0].header }}</div>
                <div class="cta-description mt-4">
                    <div *ngFor="let paragraph of callToAction[0].description.content">
                        <p>{{ paragraph.content[0].value }}</p>
                    </div>
                </div>
                <div class="buttons mt-4">
                    <ng-container *ngFor="let button of callToAction[0].buttons; let i = index">
                        <button *ngIf="i === 0" type="button" class="btn btn-outline-primary btn-block cta-buttons"
                            [style.color]="button.fields.color" [style.border-color]="button.fields.color" (click)="redirectTo(button.fields.url)">
                            {{ button.fields.name }}</button>

                        <button *ngIf="i === 1" type="button" class="btn btn-block cta-buttons"
                            [style.color]="button.fields.color" style="box-shadow: none;" (click)="openHubspotChat()">
                            <span class="me-2" *ngIf="button.fields.icon">
                                <img [src]="button.fields.icon.fields.file.url" [alt]="button.fields.icon.fields.title">
                            </span>
                            {{ button.fields.name }}</button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-sm-12">
            <ng-container *ngIf="topBrands">
                <h3 class="brand-header text-center">{{topBrands.sectionName}}</h3>
                <div class="d-flex justify-content-center mt-4">
                    <div class="clearfix d-flex align-items-center pe-2" style="cursor: pointer;" (click)="scrollLeft(overflowBrands, 'overflowBrands')">
                        <i class="fas fa-chevron-left float-start" 
                            *ngIf="topBrands.brandImage.length > 6"></i>
                    </div>
                    <div class="custom-scroll-main" #overflowBrands>
                        <div class="col-sm-2 text-center brand-block" data-mdb-ripple-color="light"
                            *ngFor="let brand of topBrands.brandImage">
                            <a href="{{brand.fields.description}}">
                                <img loading="lazy" src="{{brand.fields.file.url}}"
                                    class="brand-image rounded-circle image-background"
                                    [alt]="'Brand Image of ' + brand.fields.title" />
                            </a>

                            <p class="brand-title mt-2">
                                {{ brand.fields.title }}
                            </p>
                        </div>
                    </div>
                    <div class="clearfix d-flex align-items-center pe-2" style="cursor: pointer;" (click)="scrollRight(overflowBrands, 'overflowBrands')">
                        <i class="fas fa-chevron-right float-end"
                            *ngIf="topBrands.brandImage.length > 6"></i>
                    </div>

                </div>
            </ng-container>
        </div>
    </div>

    <div *ngIf="faqs" class="mt-4 ps-4 pe-4 pt-4" style="background: #FAFAFA; padding-bottom: 75px;">
        <h3 class="faq-header mt-4">{{faqs[0].header}}</h3>

        <div class="container mt-2 d-flex justify-content-center">
            <mdb-accordion [multiple]="true">
                <mdb-accordion-item *ngFor="let faq of faqs[0].faqItems"
                    style="background: #EFEFEF; color: #000; width: 700px; margin-bottom: 1rem;">
                    <ng-template mdbAccordionItemHeader><span
                            class="faq-question">{{faq.fields.question}}</span></ng-template>
                    <ng-template mdbAccordionItemBody>
                        {{faq.fields.answer.content[0].content[0].value}}
                    </ng-template>
                </mdb-accordion-item>
            </mdb-accordion>
        </div>
    </div>
</ng-container>

<ng-template #mobileView>


        <div *ngIf="carouselHeader" class="row">
            <mdb-carousel [controls]="true" [indicators]="true" [animation]="'fade'">
                <mdb-carousel-item *ngFor="let slide of carouselHeader[0]?.images">
                    <img [src]="slide.fields.file.url" class="d-block img-fluid" alt="..." />
                </mdb-carousel-item>
            </mdb-carousel>
        </div>

        <div *ngIf="categoryGallery" class="row mt-5 overflow-hidden">
            <h3 class="category-header">{{ categoryGallery[0].header }}</h3>
            <p class="category-subheader">{{ categoryGallery[0].subheader }}</p>
            <div class="overflow-scroll">
                <div class="col-6 scroll-item"
                    *ngFor="let category of categoryGallery[0].categories" (click)="redirectTo(category.fields.url)">
                    <a>
                        <img loading="lazy" src="{{ category.fields.images[0].fields.file.url }}" class="mobile-category-images"
                        [alt]="'Category Image of ' + category.fields.name" />
                        <span class="category-name">{{ category.fields.name }}</span>
                    </a>
                </div>
            </div>
        </div>

        <div *ngIf="keyFeatures" class="row key-features">
            <div *ngFor="let feature of keyFeatures[0].features" class="col-sm-3">
                <div class="row">
                    <div class="col-sm-12 text-center key-feature-item-mobile">
                        <img loading="lazy" src="{{feature.fields.icon.fields.file.url}}"
                            class="img-fluid key-feature-item-mobile" [alt]="feature.title" />
                        <span class="mobile-key-feature-name">{{feature.fields.name}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div style="background: #FAFAFA;">
            <div *ngIf="callToAction" style="padding: 50px;">
                <div class="mobile-text-container text-center">
                    <div class="cta-header">{{ callToAction[0].header }}</div>
                    <div class="cta-description mt-4">
                        <div *ngFor="let paragraph of callToAction[0].description.content">
                            <p>{{ paragraph.content[0].value }}</p>
                        </div>
                    </div>
                    <div class="mt-4 d-flex justify-content-center">
                        <ng-container *ngFor="let button of callToAction[0].buttons; let i = index">
                            <button *ngIf="i === 0" type="button" class="btn btn-outline-primary btn-block cta-buttons"
                                [style.color]="button.fields.color" [style.border-color]="button.fields.color" (click)="redirectTo(button.fields.url)">
                                {{ button.fields.name }}</button>

                            <button *ngIf="i === 1" type="button" class="btn btn-block cta-buttons"
                                [style.color]="button.fields.color" style="box-shadow: none;" (click)="openHubspotChat()">
                                <span class="me-2" *ngIf="button.fields.icon">
                                    <img [src]="button.fields.icon.fields.file.url"
                                        [alt]="button.fields.icon.fields.title">
                                </span>
                                {{ button.fields.name }}</button>
                        </ng-container>
                    </div>
                </div>
            </div>
                <img *ngIf="callToAction?.[0]?.image?.fields?.file?.url" [src]="callToAction[0].image.fields.file.url" [alt]="callToAction[0].image.fields.title" class="img-fluid">
        </div>

        <div class="row mt-5">
                <ng-container *ngIf="topBrands">
                    <h3 class="brand-header text-center">{{topBrands.sectionName}}</h3>
                    <div class="d-flex justify-content-center mt-4">
                        <div class="custom-scroll-main" #overflowBrands>
                            <div class="mobile-brands text-center brand-block" data-mdb-ripple-color="light"
                                *ngFor="let brand of topBrands.brandImage">
                                <a href="{{brand.fields.description}}">
                                    <img loading="lazy" src="{{brand.fields.file.url}}"
                                        class="brand-image rounded-circle image-background"
                                        [alt]="'Brand Image of ' + brand.fields.title" />
                                </a>

                                <p class="brand-title mt-2">
                                    {{ brand.fields.title }}
                                </p>
                            </div>
                        </div>
                    </div>
                </ng-container>
        </div>

        <div *ngIf="faqs" class="mt-4 mb-4 p-4" style="background: #FAFAFA;">
            <h3 class="faq-header mt-4">{{faqs[0].header}}</h3>

            <div class="container mt-2 d-flex justify-content-center">
                <mdb-accordion [multiple]="true">
                    <mdb-accordion-item *ngFor="let faq of faqs[0].faqItems"
                        style="background: #EFEFEF; color: #000; width: 400px; margin-bottom: 1rem;">
                        <ng-template mdbAccordionItemHeader><span
                                class="faq-question">
                                {{faq.fields.question}}
                            </span>
                            </ng-template>
                        <ng-template mdbAccordionItemBody>
                            {{faq.fields.answer.content[0].content[0].value}}
                        </ng-template>
                    </mdb-accordion-item>
                </mdb-accordion>
            </div>
        </div>

</ng-template>

<ng-template #altDesign>
    <div class="col-sm-6" *ngFor="let product of designToolProducts">
        <div class="bg-image hover-overlay ripple rounded px-1" data-mdb-ripple-color="light">
            <a href="{{product.url}}">
                <img loading="lazy" src="{{product.productImage.fields.file.url}}" class="img-fluid"
                    [alt]="'Product Image of ' + product.brand + ' ' + product.styleId + ' ' + product.name" />
                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
            </a>
            <div class="">
                <span class="fw-bold">
                    {{ product.brand }}
                </span>
                <span>
                    {{ product.styleId }} {{ product.name }}
                </span>
            </div>
            <div>
                <span class="fw-lighter">
                    in {{ product.category }}
                </span>
            </div>
        </div>
    </div>
</ng-template>